module.exports = __webpack_public_path__ + "d480d07b9dd0930aaaa9c9e870dfbf08.jpg";